export const platformKeyCookieKey = "X-Platform-Key";
export const currencyCodeCookieKey = "currency_code";
export const i18nRedirectCookieKey = "i18n_redirected";
